import * as React from 'react';

function UserManagementIcon(props) {
  return (
    <svg
      id='Group_640'
      data-name='Group 640'
      xmlns='http://www.w3.org/2000/svg'
      width={68.077}
      height={72.36}
      viewBox='0 0 68.077 72.36'
      {...props}
    >
      <path
        id='Path_355'
        data-name='Path 355'
        d='M45.084,18.042A19.042,19.042,0,1,1,26.042-1,19.042,19.042,0,0,1,45.084,18.042Z'
        transform='translate(7.996 1)'
        fill='#fff'
      />
      <path
        id='Path_356'
        data-name='Path 356'
        d='M37.1,11A34.255,34.255,0,0,0,3.063,41.467a7.416,7.416,0,0,0,7.379,7.617H63.759a7.417,7.417,0,0,0,7.381-7.617A34.257,34.257,0,0,0,37.1,11Z'
        transform='translate(-3.063 23.276)'
        fill='#fff'
      />
    </svg>
  );
}
export default UserManagementIcon;
